import React, { memo } from "react";
import { ColorPicker } from "@progress/kendo-react-inputs";
import useStyles from "./styles";
import { Box, Typography } from "@material-ui/core";

const ColorSelector = ({ register, ...props }) => {
  const classes = useStyles();
  const selectedColor = "#FFFFFF";
  const paletteSettings = {
    palette: [
      "#DB3737",
      "#E3547E",
      "#DE7821",
      "#33B4A0",
      "#008F5B",
      "#0081BE",
      "#0A3264",
      "#A66FAE",
      "#572584",
      "#FFFFFF",
    ],
    columns: 3,
    tileSize: 25,
  };
  return (
    <Box className={classes.root}>
      {props.labelText ? (
        <Typography variant="body2" className={classes.formLabel}>
          {props.labelText}
          {/* <span className="MuiInputLabel-asterisk">*</span> */}
        </Typography>
      ) : null}
      <ColorPicker
        {...props}
        {...register}
        defaultValue={selectedColor}
        paletteSettings={paletteSettings}
        inputProps={{ "data-testid": "input-change" }}
        // title="asfdasfaf"      // Tooltip
        popupSettings={{
          className: classes.colorPicker,
        }}
        // open
      />
    </Box>
  );
};

export default memo(ColorSelector);
